<template>
    <v-toolbar color="primary" flat dark>
        <v-toolbar-title>
            <v-btn fab small elevation="0" dark>
                <v-icon>mdi-account</v-icon>
            </v-btn>
            Store
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <v-btn icon dark>
                <v-icon>mdi-video</v-icon>
            </v-btn>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon dark v-bind="attrs" v-on="on">
                        <v-icon>mdi-phone</v-icon>
                    </v-btn>
                </template>
                <span>Call To Store</span>
            </v-tooltip>
            <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
    </v-toolbar>
</template>
<script>
export default {
    data: () => ({
        items: [
            { title: 'Opcion 1'},
            { title: 'Opcion 2'},
            { title: 'Opcion 3'},
        ]
    })
}
</script>